var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.063 19.294l-6.78-6.78a.906.906 0 01-.22-.334A1.111 1.111 0 014 11.794c0-.136.022-.265.065-.385a.912.912 0 01.218-.334l6.78-6.78c.188-.188.423-.286.706-.295a.957.957 0 01.732.295.962.962 0 01.321.707.95.95 0 01-.295.732l-5.034 5.033h11.48c.29 0 .535.099.732.296a.99.99 0 01.295.731.997.997 0 01-.295.733.989.989 0 01-.732.295H7.493l5.034 5.034c.188.188.286.427.295.719a.891.891 0 01-.295.719.933.933 0 01-.72.308c-.29 0-.539-.103-.744-.308z",
    fill: "currentColor"
  })));
}
export default SvgArrowLeft;